<template>
  <CentralSystemDescriptionList :item="model" />
</template>

<script setup lang="ts">
import { CentralSystem } from '@infuse/e-connector/central-system/domain';
import { CentralSystemDescriptionList } from '@infuse/e-connector/central-system/ui';

interface Props {
  model: CentralSystem;
}
withDefaults(defineProps<Props>(), {});
</script>
